import React from 'react'
import { Button } from '../../../components/UI/Button'
import { GlossaryListGroup } from '../types'
import { Styled } from './GroupLetter.styled'

export const GroupLetter = ({
  letter,
  groups,
  onOpen,
  onClose,
}: {
  letter: string
  groups: GlossaryListGroup[]
  onOpen: () => void
  onClose: () => void
}) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const containerRef = React.useRef<HTMLDivElement | null>(null)

  const handleClick = React.useCallback(() => {
    setIsOpen(!isOpen)
    if (isOpen) {
      onClose()
    } else {
      onOpen()
    }
  }, [isOpen])

  const onClickItem = React.useCallback(() => {
    setIsOpen(false)
    onClose()
  }, [onClose])

  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false)
        onClose()
      }
    }

    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [onClose])

  return (
    <Styled.Container isOpen={isOpen} ref={containerRef}>
      <Button onClick={handleClick} $size="xsmall" $variant="tertiary" iconRight="arrow-down-small" $ignoreTheme>
        <Styled.GroupLetter>{letter}</Styled.GroupLetter>
      </Button>
      <Styled.Dropdown isOpen={isOpen}>
        <Styled.DropdownInner>
          {groups.map(group => (
            <Button as="a" href={`#${group.id}`} $size="xsmall" $ignoreTheme $variant="tertiary" onClick={onClickItem}>
              {group.letter}
            </Button>
          ))}
        </Styled.DropdownInner>
      </Styled.Dropdown>
    </Styled.Container>
  )
}
